import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1875b04e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1875b04e&lang=less&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=1875b04e&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1875b04e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1875b04e')) {
      api.createRecord('1875b04e', component.options)
    } else {
      api.reload('1875b04e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1875b04e&scoped=true", function () {
      api.rerender('1875b04e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportCenter/audit/index.vue"
export default component.exports